<div *ngIf="player" autosize id="simulation_player">
  <div
    style="flex: 1 0px; margin: 0px; padding-left: 10px; padding-right: 10px"
  >
    <mat-slider
      #ngSlider
      [disabled]="!player.canSeek() || disabled"
      [max]="player?.buffer.getNRKeyframes() - 1 || 0"
      [min]="0"
      id="position-slider"
      style="width: calc(100% - 12px); height: 40px"
      ><input
        #ngSliderThumb="matSliderThumb"
        (change)="
          sliderChange({
            source: ngSliderThumb,
            parent: ngSlider,
            value: value
          })
        "
        (input)="
          disableSliderUpdate({
            source: ngSliderThumb,
            parent: ngSlider,
            value: value
          })
        "
        [(ngModel)]="value"
        matSliderThumb
      />
    </mat-slider>
  </div>

  <div class="player-action-wrapper">
    <div class="left-section">
      <button
        (click)="play()"
        [disabled]="!(player.ready$ | async) || disabled"
        [hidden]="player.isPlaying()"
        aria-label="Play"
        class="play_pause_btn"
        color="primary"
        mat-icon-button
      >
        <mat-icon svgIcon="play-svgrepo-com"></mat-icon>
      </button>
      <button
        (click)="pause()"
        [disabled]="!(player.ready$ | async) || disabled"
        [hidden]="!player.isPlaying()"
        aria-label="Pause"
        class="play_pause_btn"
        color="primary"
        mat-icon-button
      >
        <mat-icon svgIcon="pause-svgrepo-com"></mat-icon>
      </button>
      <button
        (click)="stop()"
        [disabled]="!(player.ready$ | async) || disabled"
        aria-label="Stop"
        class="stop_btn"
        color="primary"
        mat-icon-button
      >
        <mat-icon svgIcon="stop-svgrepo-com"></mat-icon>
      </button>
      <div style="display: flex; justify-content: center; align-items: center">
        <span
          id="current_time"
          style="margin-left: 10px; max-height: fit-content"
          >{{ player.getCurrentDisplayTime() }}</span
        >
        <span
          style="max-height: fit-content; margin-left: 2px; margin-right: 2px"
          >/</span
        >
        <span
          id="end_time"
          style="margin-right: 10px; max-height: fit-content"
          >{{ player.getEndDisplayTime() }}</span
        >
      </div>
    </div>
    <div class="right-section">
      <mat-menu #speedSelectionMenu="matMenu">
        <!-- NOTE: Workaround for broken mat-options used in field component -->
        <button
          mat-menu-item
          *ngFor="let option of speedOptions"
          (click)="setPlaybackSpeed(option)"
        >
          {{ option }}x
        </button>
      </mat-menu>
      <button
        [disabled]="disabled"
        [matMenuTriggerFor]="speedSelectionMenu"
        class="play-speed-selector"
        style="right: 10px"
        mat-stroked-button
      >
        {{ rosbagPlayerFields[0].formControl.value }}x
      </button>

      <ng-container *ngIf="movementBoxOptions?.length">
        <mat-menu #movementBoxSelectionMenu="matMenu">
          <!-- NOTE: Workaround for broken mat-options used in field component -->
          <button mat-menu-item (click)="setMovementBox(true)">
            <mat-icon style="margin-left: 8px">close</mat-icon>
            None (Hide all movement boxes)
          </button>
          <button
            mat-menu-item
            *ngFor="let option of movementBoxOptions"
            (click)="option.isVisible = !option.isVisible; setMovementBox()"
          >
            <mat-checkbox [checked]="option.isVisible"></mat-checkbox>
            {{ option.label }}
          </button>
        </mat-menu>
        <button
          mat-icon-button
          color="primary"
          aria-label="Show movement box"
          matTooltip="Show movement box"
          class="movement-box-selector"
          style="right: 10px"
          [disabled]="disabled"
          [matMenuTriggerFor]="movementBoxSelectionMenu"
        >
          <mat-icon>
            {{ movementBoxSelected ? 'deselect' : 'select_all' }}
          </mat-icon>
        </button>
      </ng-container>

      <button
        (click)="togglePlayerMode(modeEnum.THEATER)"
        [disabled]="disabled"
        aria-label="Theater mode"
        class="theater_btn"
        color="primary"
        mat-icon-button
      >
        <mat-icon>
          {{ playerMode === modeEnum.THEATER ? ' crop_square' : ' crop_16_9' }}
        </mat-icon>
      </button>
      <button
        (click)="togglePlayerMode(modeEnum.FULLSCREEN)"
        [disabled]="disabled"
        aria-label="Fullscreen"
        class="fullscreen_btn"
        color="primary"
        mat-icon-button
      >
        <mat-icon>
          {{
            playerMode === modeEnum.FULLSCREEN
              ? 'fullscreen_exit'
              : 'fullscreen'
          }}
        </mat-icon>
      </button>
    </div>
  </div>
</div>
